import React, { useState, useContext } from 'react'
// import MoreVertIcon from '@material-ui/icons/MoreVert'
import { Popover } from '@material-ui/core'
import { Edit, MoreVert, FileCopy, Delete, People, Work, History } from '@material-ui/icons'
import Modal from 'react-modal'
import RenameList from './RenameList/RenameList'
import ClonePropertyList from './ClonePropertyList/ClonePropertyList'
import DeletePropertyList from './DeletePropertyList/DeletePropertyList'
import SharePropertyList from './SharePropertyList/SharePropertyList'
import AddListToDeal from './AddListToDeal/AddListToDeal'
import listContext from '../../../Common/context/context'
import { useKeycloak } from '@react-keycloak/web'
import { getUserSFId } from '../../../PropertySearch/Utility/Utility'

const ListOptions = () => {

    const { keycloak } = useKeycloak()
    let { propertyList } = useContext(listContext)
    const [anchorEl, setAnchorEl] = useState(null)
    const [modalIsOpen, setIsOpen] = useState(false)
    const [disableClose, setdisableClose] = useState(false)
    const [selectedOption, setSelectedOption] = React.useState('')

    const customStyles = {
        content: {
            top: '30%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -40%)',
            padding: '0px !important'
        },
        overlay: { zIndex: 1050 }
    }

    const handleShowOptions = event => {
        setAnchorEl(event.currentTarget)
    }

    const handleClose = () => {
        setAnchorEl(null)
    }

    const open = Boolean(anchorEl)

    const showDeleteIcon = item => {
        let returnVal = false

        // if (item.userId && item.userId === keycloak.subject) {
        //     returnVal = true
        // }

        // if (!returnVal && item.omniViewUserId && item.omniViewUserId === getUserSFId()) {
        //     returnVal = true
        // }

        if (item.omniViewUserId && item.omniViewUserId === getUserSFId()) {
            returnVal = true
        }

        return returnVal
    }

    const componentToLoad = {
        RenameList: <RenameList closeModal={closeModal} setdisableClose={setdisableClose}></RenameList>,
        ClonePropertyList: <ClonePropertyList closeModal={closeModal} setdisableClose={setdisableClose}></ClonePropertyList>,
        DeletePropertyList: <DeletePropertyList closeModal={closeModal} toListPage={true} setdisableClose={setdisableClose}></DeletePropertyList>,
        SharePropertyList: <SharePropertyList closeModal={closeModal} setdisableClose={setdisableClose}></SharePropertyList>,
        AddListToDeal: <AddListToDeal closeModal={closeModal} setdisableClose={setdisableClose}></AddListToDeal>
    }

    function openModal(inpuVal) {
        setSelectedOption(inpuVal)
        setIsOpen(true)
        handleClose()
    }

    function closeModal() {
        if (!disableClose) {
            setIsOpen(false)
        }
    }

    return (
        <>
            <button data-testid="test-btn-show-list-options" className="p-2 btn rounded-full" onClick={handleShowOptions}>
                <MoreVert fontSize="small"></MoreVert>
            </button>
            <Popover onClose={handleClose} open={open} anchorEl={anchorEl} data-testid="test-popover-list-options"
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left', }}
                transformOrigin={{ vertical: 'top', horizontal: 'left', }} >
                <div className="flex flex-col text-2">
                    <div>
                        <div>
                            <div data-testid="test-menuItem-save-list" onClick={() => { openModal('RenameList') }} role="button" className="p-4 flex flex-row space-x-2 hover:bg-gray-2 cursor-context-menu hover:bg-gray-15">
                                <div>
                                    <Edit fontSize="small" />
                                </div>
                                <div className="pl-4">
                                    Rename
                                </div>
                            </div>
                        </div>
                        <div>
                            <div data-testid="test-menuItem-save-list" onClick={() => { openModal('ClonePropertyList') }} role="button" className="p-4 flex flex-row space-x-2 hover:bg-gray-2 cursor-context-menu hover:bg-gray-15">
                                <div>
                                    <FileCopy fontSize="small" />
                                </div>
                                <div className="pl-4">
                                    Clone
                                </div>
                            </div>
                        </div>
                        {propertyList && showDeleteIcon(propertyList) && <div>
                            <div data-testid="test-menuItem-save-list" onClick={() => { openModal('DeletePropertyList') }} role="button" className="p-4 flex flex-row space-x-2 hover:bg-gray-2 cursor-context-menu hover:bg-gray-15">
                                <div>
                                    <Delete fontSize="small" />
                                </div>
                                <div className="pl-4">
                                    Delete
                                </div>
                            </div>
                        </div>}
                    </div>
                    <div className="border-t-1 border-base">
                        <div>
                            <div data-testid="test-menuItem-save-list" onClick={() => { openModal('SharePropertyList') }} role="button" className="p-4 flex flex-row space-x-2 hover:bg-gray-2 cursor-context-menu hover:bg-gray-15">
                                <div>
                                    <People fontSize="small" />
                                </div>
                                <div className="pl-4">
                                    Shared with ({propertyList && propertyList.sharedWithUsers.length})
                                </div>
                            </div>
                        </div>
                        <div>
                            <div data-testid="test-menuItem-save-list" onClick={() => { openModal('AddListToDeal') }} role="button" className="p-4 flex flex-row space-x-2 hover:bg-gray-2 cursor-context-menu hover:bg-gray-15">
                                <div>
                                    <Work fontSize="small" />
                                </div>
                                <div className="pl-4">
                                    Add to deal ({propertyList && propertyList.sharedDeals.length})
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </Popover>
            <Modal ariaHideApp={false} isOpen={modalIsOpen} onRequestClose={closeModal}
                closeTimeoutMS={500} style={customStyles} >
                {componentToLoad[selectedOption]}
            </Modal>
        </>
    )
}


export default ListOptions
